import { TreeTableComponent, TreeNode } from '@farris/ui-treetable';
import { FavoriteAction, FAVORITE_FIELD_NAME } from '../lookup-displaytype';
import { LOAD_DATA_TYPE, LookupGridResult } from '../lookup-grid-options';
import { cloneDeep } from 'lodash-es';
import { Observable, of, Subject } from 'rxjs';
import { LookupGridComponent } from '../lookup-grid.component';
import { take, tap, catchError } from 'rxjs/operators';
import { LookupSelectionService } from './lookup-selection.service';
import { FilterCondition } from '@farris/ui-common/types';


export class TreeTableEventManager {
    private lookupSelectionSer: LookupSelectionService;
    private _sortState = null;
        /**
     * æ è¯å½åæ°æ®æ¯å¦æ¥è¯¢ç»æ
     */
    private IS_SEARCH_RESULT = false;


    constructor(private ins: LookupGridComponent) {
        this.lookupSelectionSer = this.ins.lookupSelectionSer;
    }

    conditionsChange(conditions) {
        this.ins.conditions = conditions;
        if (this.ins.uri) {
            if (conditions && conditions.length === 1 && conditions[0].code == '*') {
                this.ins.conditions = [];
                return this.searchTreeData({ field: '*', value: conditions[0].value });    
            }
            return this.searchTreeData({ field: '*', value: '' });
        } else {
            this.ins.query.emit({ conditions, instance: this.ins });
        }
    }

    private setCheckedRowNodeStatus(tt: TreeTableComponent) {
        const removeFun = () => {
           tt['checked_rows_status'] = null;
        }

        if (!tt || this.ins.singleSelect) {
            return removeFun;
        }

        var rowsMap = tt['getCurrentRowNodesMap']();
        const checkedRows = new Map(tt.checkeds.map(n => n.id).map<[string, any]>(n => {
            const rowNode = rowsMap.get(n);
            if (rowNode) {
                const { indeterminate, isChecked } = rowNode;
                return [n, { indeterminate, isChecked }];
            } else {
                return  [n, null];
            }
        }));

        tt['checked_rows_status'] = checkedRows;

        return removeFun;
    }

    searchTreeData(search: { field: string; value: string }) {
        const tt = this.ins.componentRef.instance as TreeTableComponent;
        // å¤æ­uri ååºsearch.emit();
        if (this.ins.searching) {
            return;
        } else {
            this.ins.searching = true;
        }

        this.ins.showLoading();
        if (tt&& tt.psRef && tt.psRef.directiveRef) {
            tt.psRef.directiveRef.scrollToTop(0);
        }

        let pageInfo: any = null;
        if (tt.pagination) {
            pageInfo = {
                pageIndex: 1,
                pageSize: tt.pageSize
            }
        }

        return this.ins.httpMgr.getData({ search, sortName: tt.sortName, sortOrder: tt.sortOrder, pageInfo }, 'search').pipe(
            tap(() => {
                this.ins.searching = false;
            }),
            catchError((err) => {
                this.ins.searching = false;
                return of(err);
            })
        ).subscribe(resData => {
            this.ins.closeLoading();
            if (resData) {
                // this.ins.items = resData.items;
                const rowNodeStatusMap =  this.setCheckedRowNodeStatus(tt);

                tt.clearAll();

                const treeInfo = this.ins.gridOptions.treeInfo;
                if (!treeInfo['treeDataIsInit']) {
                    if (treeInfo.layerType.toLowerCase() === 'pathcode') {
                        this.ins.items = this.ins.lookupUtils.makeTree(this.ins.items, treeInfo);
                    } else {
                        this.ins.items = this.ins.lookupUtils.makeTreeWithParentID(
                            this.ins.items,
                            '',
                            treeInfo.dataField ? `${treeInfo.dataField}.${treeInfo.parentField}` : treeInfo.parentField,
                            this.ins.idField
                        );
                    }
                }


                const checkNodes = (nodes): TreeNode[] => {
                    if (nodes && nodes.length) {
                        return nodes.map((node: TreeNode) => {
                            if (node.hasOwnProperty('addtional')) {
                                node.selectable = !node['addtional'];
                            }

                            if (node.children && node.children.length) {
                                checkNodes(node.children);
                            } else {
                                if (this._isLoadAllTreeData(tt) && (!search || search.value === '' || search.value === undefined)) {
                                    node.leaf = true;
                                }
                            }
                            return node;
                        });
                    }
                    return nodes;
                };

                const _nodes = checkNodes(resData.items);
                // if (_nodes && _nodes.length && _nodes[0].children && _nodes[0].children.length) {
                //     _nodes[0].expanded = true;
                //     _nodes[0].children = this.ins.expandFirstNode(_nodes[0].children);
                // }
                // this.ins.items = _nodes;

                // æ¥è¯¢ç»æä¸­å±å¼ææèç¹
                this.ins.items = this.ins.expandFirstNode(_nodes);

                // å è½½æ¶èæ°æ®
                if (this.ins.useFavorite) {
                    // æ´æ°æ°æ®çæ¶èç¶æ
                    this.ins.favHelper.updateFavoritesStatus(this.ins.items);
                }

                if (tt.pagination) {
                    tt.scrollToY(0)
                    tt.updatePageInfo({pageSize: tt.pageSize, pageIndex: 1, total: resData.total });
                }

                tt.loadData(this.ins.items);
                // // å±å¼æ¥è¯¢ç»æã
                // if (search.value && this.ins.items.length) {
                //     tt.toggleExpand(this.ins.items[0], true);
                // }
                tt.resize();

                this.IS_SEARCH_RESULT = true;

                this.ins.selectionMgr.selectCurrentValue();

                rowNodeStatusMap();
            }

            this.ins.search.emit(search);
        });
    }

    private getChildren(
        parentPath,
        parentLayer,
        searchData: { searchField: string; searchValue: string },
        pageInfo?: {pageSize: number; pageIndex: number, category?: 'children'|'all'}
    ): Observable<any> {
        const uri = this.ins.gridOptions.uri;
        const search = { parentLayer, category: 'children', ...searchData };

        const isParentId = this.ins.treeInfo && this.ins.treeInfo.layerType === 'parentId';
        if (isParentId) {
            search['parentId'] = parentPath;
        } else {
            search['parentPath'] = parentPath;
        }
        
        const param: any = {
            searchValue: '',
            customData: this.ins.customData,
            enableFullTree: this.ins.enableFullTree,
            loadTreeDataType: this.ins.loadTreeDataType
        };
        
        const tt = this.ins.componentRef.instance as TreeTableComponent;
        if (tt && tt.sortName) {
            // tfs 639865
            const col = this.ins.columns.find(n => n.field === tt.sortName);
            const _sortName = col ? col.fieldPath ? col.fieldPath : col.field : tt.sortName;
            Object.assign(search, {
                sortName: _sortName,
                sortOrder: tt.sortOrder
            });
        }

        if (tt.pagination && !isParentId && pageInfo !=null) {
            param['pageIndex'] = pageInfo?pageInfo.pageIndex: 1;
            param['pageSize']  = pageInfo?pageInfo.pageSize: this.ins.treeTableOptions.pageSize;
            param['enableTreePagination'] = true;
            if (pageInfo.category) {
                search.category = pageInfo.category;
            }
        }

        if (this.IS_SEARCH_RESULT) {
            param.enableFullTree = false;
            param.loadTreeDataType = 'layerload';

            if (isParentId) {
                // æ å½¢å¸®å©æ¥è¯¢åï¼å±å¼èç¹æ¶å°ç¸å³æ¥è¯¢åæ°ä¼ éå°åç«¯ 2022-09-13
                search.searchValue = '';
                search.searchField = '*';
            }
            // param.searchValue = JSON.stringify(search);
        }

        param.searchValue = JSON.stringify(search);

        if (this.ins.helpId) {
            param['helpId'] = this.ins.helpId;
        }
       

        if (this.ins.conditions && this.ins.conditions.length) {
            param.searchConditions = cloneDeep(this.ins.conditions);
        }
       
        return this.ins.http.getData(uri, param);
    }


    private _isLoadAllTreeData = (tt) => {
        if (this.ins.loadTreeDataType === 'default') {
            return tt.loadDataType === 'all';
        } else {
            return this.ins.loadTreeDataType === 'loadall';
        }
    };

    private _isAsyncLoadTreeData = (tt) => {
        if (this.ins.loadTreeDataType === 'default') {
            return tt.loadDataType === 'async';
        } else {
            return this.ins.loadTreeDataType === 'layerload';
        }
    };

    private needGetAllChildNodes(node?: TreeNode) {
        const isNeed = this.ins.treeInfo.loadDataType !== "all" && this.ins.treeInfo.layerType === "pathcode" &&
             this.ins.enableCascade && (this.ins.cascadeStatus === 'enable' || this.ins.cascadeStatus === 'down') && this.ins.isGetAllChidlNodes;
        return  node ? node.data && !node.leaf && isNeed : isNeed;
    }

    private setAllChildNodesToSelections(parentPaths: string[]) {
        this.ins.showLoading();
        this.ins.httpMgr.getData({parentsIds: parentPaths}, 'allChildren').subscribe(data => {
            this.ins.closeLoading();
            if (data.items && data.items.length) {
                // æ´æ°éä¸­è®°å½ç¼å­
                const _items = data.items.filter(n => !n.addtional && (n.selectable || n.selectable === undefined));
                if (_items && _items.length) {
                    const nodesData = _items.map(n => n.data);
                    this.ins.lookupSelectionSer.updateSelections(nodesData, true);
                    this.ins.checkedChange.emit({ data: nodesData, isCheck: true  });
                }
            }
        });
    }

    private updateSelectionsWhenGetAllChildren(node, loadAllChilds = false) {
        if (this.needGetAllChildNodes(node) || loadAllChilds) {
            const treeInfo = this.ins.gridOptions.treeInfo;
            const treeInfoField = treeInfo.dataField;
            if (treeInfoField) {
                const parentPath = this.ins.getPathCode(node.data, treeInfo);
                // const parentLayer = this.ins.getLayerData(e.node.data, treeInfo);
                // const { field = '*', value = '' } = {
                //     ...tt.searchData
                // };
                this.setAllChildNodesToSelections([parentPath]);
            } else {
                this.ins.writeConsole('æªæ¾å°åçº§ä¿¡æ¯ã');
            }
        }
    }

    bindTreetableEvent() {
        const tt = this.ins.componentRef.instance as TreeTableComponent;
        const _searchTreeData = (searchparam: any) => {
            if (this.ins.remoteSearch) {
                this.ins._searchState = searchparam;
                this.searchTreeData(searchparam);
            } else {
                if (this.ins.useInsideSearchHandler) {
                    tt.searchHandle.search(searchparam.field, searchparam.value, 'client');
                } else {
                    this.ins.search.emit(searchparam);
                }
            }
        };

        const isLoadAllTreeData = () => {
            return this._isLoadAllTreeData(tt);
        };

        const isAsyncLoadTreeData = () => {
            return this._isAsyncLoadTreeData(tt);
        };

        tt.checkDeepNodes = true;
        tt.includeParentWhenCascadeUp = true;

        tt.dblClickExpand = !this.ins.singleSelect; // ç¦ç¨åå»å±å¼èç¹
        tt.allColumnsTitle = this.ins.allColumnsTitle; // this.displayInfo.allColumns;
        tt.idField = this.ins.idField;
        tt.columns = this.ins.columns;

        // tfs 766662
        tt.columns.forEach(col => {
            if (col.field !== FAVORITE_FIELD_NAME) {
                col.showTips = true;
            }
        });

        tt.searchFields = this.ins.gridOptions.searchFields;
        if (this.ins.treeInfo) {
            tt.loadDataType = this.ins.treeInfo.loadDataType;
            tt.virtualized = true;
            if (!this.ins.isTextChange) {
                this.ins.allData = cloneDeep(this.ins.items);
            } else {
                this.ins.allData = [];
            }
        }

        if (this.ins.gridOptions.treeInfo) {
            tt.onlySelectLeaf = this.ins.gridOptions.treeInfo.onlySelectLeaf;
            tt.loadDataType = this.ins.gridOptions.treeInfo.loadDataType;
        }

        if (!tt.singleSelect) {
            tt.checkOnSelect = true;
            tt.selectOnCheck = true;
            tt.showCheckbox = true;
            tt.showCheckAll =  this.ins.showCheckAll;
            // å¯ç¨å¤éåï¼åæ¶å¯ç¨çº§èéæ©
            if (this.ins.enableCascade) {
                this.cascadeValueChanged(this.ins.cascadeStatus);
            } else {
                tt.cascadeCheck = false;
                tt.cascadeDown = false;
                tt.cascadeUp = false;
            }
        }

        tt.enableFindText = this.ins.enableFindText;
        // tt.findField = this.textField;
        tt.nodeSelected.subscribe((e: any) => {
            // if (this.ins.favoritesComponentRef && this.ins.singleSelect) {
            //     const ftt = this.ins.favoritesComponentRef.instance as TreeTableComponent;
            //     ftt.clearSelections();
            // }
            if (this.ins.singleSelect) {
                this.lookupSelectionSer.clearSelections();
            }
            this.lookupSelectionSer.updateSelections([e.node.data]);
            this.ins.checkedChange.emit({ data: [e.node.data] , isCheck: true  });
        });

        tt.nodeChecked.subscribe( e => {
            if (!this.ins.singleSelect) {
                let data = null;
                if (e.nodes && e.nodes.length) {
                    data = e.nodes.map(n => n.data);
                } else {
                    if (Array.isArray(e.node)) {
                        data = e.node.map(n => n.data);
                    } else {
                        data = [e.node.data];
                    }
                }

                if (this.needGetAllChildNodes(e.node)) {
                    this.updateSelectionsWhenGetAllChildren(e.node);
                } else {
                    this.ins.multiSelMgr.updateSelections(data);
                    this.ins.checkedChange.emit({ data, isCheck: true  });
                }
            }
        });

        tt.nodeUnChecked.subscribe((e: any) => {
            if (e && e.node) {
                let nodeData = null;
                if (e.node.data) {
                    nodeData = e.node.data;
                } else {
                    if (e.node.node && e.node.node.data) {
                        nodeData = e.node.node.data;
                    }
                }

                if (!nodeData) {
                    return;
                }

                if (!this.ins.singleSelect) {
                    this.ins.multiSelMgr.remove(e.node.id);

                    // åå±å è½½ï¼å¤éï¼åå«ä¸çº§æ¶ï¼åæ¶å¾é éè¦å°å½åèç¹çææå­çº§æ°æ®ä¹è¦åæ¶éæ©ï¼å³ä»å·²éè®°å½ä¸­ç§»é¤
                    if (tt.loadDataType !== 'all' && this.ins.treeInfo.layerType === 'pathcode' && this.ins.enableCascade &&
                        (this.ins.cascadeStatus === 'enable' || this.ins.cascadeStatus === 'down')) {
                        // if (e.node.children && e.node.children.length) {
                        //     const nodes = e.node.children.map(n => n.data);
                        //     this.ins.lookupSelectionSer.updateSelections(nodes, false);
                        // } else {
                        //     const pathcode = this.ins.getPathCode(nodeData, this.ins.treeInfo)
                        //     this.ins.lookupSelectionSer.unselectByPathcode(pathcode);
                        // }
                        const pathcode = this.ins.getPathCode(nodeData, this.ins.treeInfo)
                        this.ins.lookupSelectionSer.unselectByPathcode(pathcode);
                    }

                    if (e.nodes && e.nodes.length) {
                        this.ins.multiSelMgr.remove(e.nodes.map(n => n.id));
                        this.ins.checkedChange.emit({ data: e.nodes.map(n => n.data), isCheck: false });
                    } else {
                        this.ins.checkedChange.emit({ data: [nodeData], isCheck: false });
                    }
                } else {
                    const ftt = this.ins.favoritesComponentRef && (this.ins.favoritesComponentRef.instance as TreeTableComponent);
                    if (ftt && ftt.findRowNode(e.node.id)) {
                        ftt.unSelectNode(e.node.id);
                    }

                    this.ins.checkedChange.emit({ data: [nodeData], isCheck: false });
                }
            }
        });

        tt.checkAll.subscribe( e => {
            const data = e.instance.checkeds.map(n => n.data);
            // tfs 717515
            //this.ins.lookupSelectionSer.loadSelections([]);

            if (this.needGetAllChildNodes()) {
                const nodes = this.ins.items.map(n => n.data);
                let parentsIds = this.ins['getParentPathCode'](nodes);
                if (parentsIds && parentsIds.length) {
                    parentsIds = parentsIds.map(
                        (n) => this.ins.getPathCode(n)
                    );
                }
                this.setAllChildNodesToSelections(parentsIds);
            } else {
                this.ins.multiSelMgr.updateSelections(data);
                this.ins.checkedChange.emit({ data, isCheck: true  });
            }

        });

        tt.unCheckAll.subscribe(() => {
            this.ins.multiSelMgr.clear();
            this.ins.checkedChange.emit({ data: [], isCheck: false  });
        });

        tt.search.subscribe(searchparam => {
            if (searchparam.field !== '*' && !searchparam.value) {
                this.ins.messagerService.warning(this.ins.mustWriteSomething);
            } else {
                searchparam.value = searchparam.value.trim();
                _searchTreeData(searchparam);
            }
        });
        if (!tt.cellClick.observers.length) {
            tt.cellClick.subscribe((e: any) => {
                if (e.col.field === FAVORITE_FIELD_NAME) {
                    e.event.stopPropagation();
                    // tslint:disable-next-line: no-string-literal
                    const classList = e.event.target['classList'];
                    if (classList.contains('f-lookup-favorite')) {
                        // classList.toggle('f-icon-star');
                        // classList.toggle('f-icon-star-outline');
                        const _this = this.ins;

                        (function each(arr) {
                            if (arr) {
                                arr.forEach(item => {
                                    const id = _this.utils.getValue(_this.idField, item.data);
                                    if (id === e.node.id) {
                                        item.data[FAVORITE_FIELD_NAME] = !item.data[FAVORITE_FIELD_NAME];
                                        return true;
                                    } else if (item.children && item.children.length > 0) {
                                        return each(item.children);
                                    } else {
                                        return false;
                                    }
                                });
                            }
                        })(this.ins.items);
                        tt.loadData(this.ins.items);

                        // æ´æ°æ¶èæ°æ®
                        this.lookupSelectionSer.updateFavoriteData( e.node.data,
                            e.node.data[FAVORITE_FIELD_NAME] ? FavoriteAction.add : FavoriteAction.delete);
                    }
                }
            });
        }
        tt.dblClick.subscribe((treeNode: TreeNode) => {
            if (this.ins.gridOptions.singleSelect) {
                if (treeNode.selectable === true || treeNode.selectable === undefined) {
                    if (this.ins.okButton) {
                        this.ins.selectItem(treeNode.data);
                    }
                } else {
                    // åéå¸®å©ä¸­ï¼ç¶èç¹ç¦æ­¢éæ©æ¶ï¼åå»å±å¼ ilink 498701
                    if (!treeNode.leaf) {
                        tt.toggleExpand(treeNode);
                    }
                }
            }
        });
        const loadAllData = isLoadAllTreeData();
        tt.columnSorted.subscribe((sort: { sortName: string; sortOrder: any; }) => {
            this._sortState = sort;
            if (isLoadAllTreeData()) {
                tt.clientSort();
            } else {
                const { sortName, sortOrder } = { ...sort };

                const col = this.ins.columns.find(n => n.field === sortName);
                const _sortName = col ? col.fieldPath ? col.fieldPath : col.field : sortName;

                const param: any = Object.assign({ sortName: _sortName, sortOrder }, { search: this.ins._searchState });

                let reqTyp: LOAD_DATA_TYPE = 'all';
                if (this.ins._searchState && this.ins._searchState.value) {
                    reqTyp = 'search';
                }

                // tfs 686635
                if (this.ins.isEnableTreePager()) {
                    param.pageInfo = {
                        pageSize: this.ins.treeTableOptions.pageSize || 20,
                        pageIndex: 1
                    }
                }
                this.ins.showLoading();
                this.ins.httpMgr.getData(param, reqTyp).subscribe(d => {
                    this.ins.closeLoading();
                    tt.clearAll();
                    const items = this.ins.checkNodeCanBeSelect(d.items, false);
                    if (this.ins.useFavorite) {
                        this.ins.favHelper.updateFavoritesStatus(items);
                    }
                    this.ins.items = items;


                    if (this.ins.isEnableTreePager()) {
                        const { pageSize, pageIndex } = d.pageInfo;
                        this.setTreeTablePageInfo(tt, pageSize, pageIndex, items);
                    } else {
                        if (this.IS_SEARCH_RESULT) {  // tfs 670430
                            tt.loadData(this.ins.expandFirstNode(items));
                        } else {
                            tt.loadData(items);
                        }
                        tt.resize();
                        this.ins.selectionMgr.selectCurrentValue();
                    }
                });
            }
        });

        tt.clearSearchValue.subscribe(() => {
            if (tt&& tt.psRef && tt.psRef.directiveRef) {
                tt.psRef.directiveRef.scrollToTop(0);
            }

            this.ins._searchState = null;
            this.IS_SEARCH_RESULT = false;
            let _items = [];
            if (this.ins.allData && this.ins.allData.length) {
                _items = this.ins.checkNodeCanBeSelect(this.ins.allData, loadAllData);
            }

            if (tt.pagination) {
                _searchTreeData({ field: '*', value: '' });
            } else {
                if (!_items || !_items.length) {
                    _searchTreeData({ field: '*', value: '' });
                } else {
                    if (!this.ins.singleSelect) {
                        tt.checkValues = this.ins.lookupSelectionSer.getSelections().map(n => this.ins.utils.getValue(this.ins.idField, n));
                    }
                    const t = this.setCheckedRowNodeStatus(tt);

                    this.ins.items = _items;
                    this.ins.favHelper.updateFavoritesStatus(this.ins.items);
                    tt.loadData(_items);
                    t();
                    setTimeout(() => {
                        const t1 = this.setCheckedRowNodeStatus(tt);
                        this.ins.selectionMgr.selectCurrentValue();
                        t1();
                    });
                }
            }
        });

        tt.expand.subscribe((tn: TreeNode) => {
            if (tn.leaf ||  tn['showLoading']) {
                return;
            }
            if (!tn.children || !tn.children.length) {
                const treeInfo = this.ins.gridOptions.treeInfo;
                if (isAsyncLoadTreeData() || this.IS_SEARCH_RESULT ) {
                    let parentPath = '';
                    let parentLayer = -1;
                    const { field = '*', value = '' } = {
                        ...tt.searchData
                    };

                    tn['showLoading'] = true;
                    tt.detectChanges();
                    if (treeInfo.layerType === 'parentId') {
                        // ç¶IDå è½½æ¹å¼
                        parentPath = tn['id'];
                    } else {
                        const treeInfoField = treeInfo.dataField;
                        if (treeInfoField) {
                            // parentPath = tn.data[treeInfoField][treeInfo.pathField];
                            parentPath = this.ins.getPathCode(tn.data, treeInfo);
                            // parentLayer = tn.data[treeInfoField][treeInfo.layerField];
                            parentLayer = this.ins.getLayerData(tn.data, treeInfo);
                        } else {
                            this.ins.writeConsole('æªæ¾å°åçº§ä¿¡æ¯ã');
                        }
                    }

                    if (!this.ins.uri) {
                        tn['showLoading'] = false;
                        this.ins.expandTreeNode.emit({
                            instance: tt, node: tn,
                            parentIdOrPath: parentPath, parentLayer, search: { value, field }
                        });

                        return;
                    }

                    this.ins.showLoading();

                    let pageInfo = null;

                    if ( tt.pagination && this.ins.treeTableOptions.paginationForChildren) {
                        pageInfo = {
                            pageIndex: tn.pagination ? tn.pagination.pageIndex : 1,
                            pageSize: tt.pageSize
                        }
                    }

                    this.getChildren(parentPath, parentLayer, {
                        searchField: field === '*' ? '*' : field,
                        searchValue: value
                    }, pageInfo).subscribe(data => {
                        this.ins.closeLoading();
                        if (tt) {
                            this.onTreeNodeExpaned(tt, tn, data);
                        }
                    });
                }
            } else {
                if (!this.ins.singleSelect && this.ins.enableCascade &&
                        (this.ins.cascadeStatus === 'enable' || this.ins.cascadeStatus === 'down') && this.ins.isGetAllChidlNodes ) {
                    /*                            
                    const rn = tt.findRowNode(tn.id);
                    tt.propagateSelectionDown(rn, rn.isChecked);
                    const selectItems = tn.children.filter(n => n.selectable).map(n => n.data);
                    this.ins.lookupSelectionSer.updateSelections(selectItems, rn.isChecked);
                    */
                }
            }
        });

        if (loadAllData && this.ins.items) {
            this.ins.treeNodeHelper.updateTreeNodeExpanded(this.ins.items);
        }

        // æ åé¡µäºä»¶ç»å®
        this.treePagerEvent(tt);

        return loadAllData;
    }


    private onTreeNodeExpaned(tt: TreeTableComponent, tn: TreeNode, data: any) {
        if (tn && data.items && data.items.length) {
            if (this.ins.useFavorite) {
                // æ´æ°å­èç¹æ¶èç¶æ
                this.ins.favHelper.updateFavoritesStatus(data.items);
            }

            const nodes = this.ins.checkNodeCanBeSelect(data.items, false);

            if (tt.pagination && data.pageInfo) {
                data.pageInfo.total = data.total;
                 // è®¾ç½®ç¶èç¹çåé¡µä¿¡æ¯
                tn.pagination = data.pageInfo;
                // ç¶èç¹å è½½å­çº§æ°æ®
                tt.loadChildren(nodes, tn);
            } else {
                tt.appendChildren(nodes, tn);
            }

            // if (tt.loadDataType !== 'all' && !this.ins.singleSelect && this.ins.isGetAllChidlNodes &&
            //     (this.ins.cascadeStatus === 'enable' || this.ins.cascadeStatus === 'down') ) {
            //     const rn = tt.findRowNode(tn.id);
            //     tt.propagateSelectionDown(rn, rn.isChecked);

            //     // æ´æ°éä¸­è®°å½ç¼å­
            //     const _items = data.items.filter(n => !n.addtional);
            //     if (_items && _items.length) {
            //         this.ins.lookupSelectionSer.updateSelections(_items.map(n => n.data), rn.isChecked);
            //     }
            // }
        }
        tn['showLoading'] = false;
        tt.detectChanges();
        tt.psRef.directiveRef.update();
        this.ins.selectionMgr.selectCurrentValue();
    }

    cascadeValueChanged($event) {
        const val = $event;
        // const tt = this.ins.componentRef.instance as TreeTableComponent;
        const instanceTyp = this.ins.activeTab === 'datalist' ? 'treetable' : 'fav';
        const tt = this.ins.lookupCmpMgr.getComponentInstance(instanceTyp) as TreeTableComponent;

        if (!tt) {
            return;
        }

        switch (val) {
            case 'enable':
                tt.cascadeCheck = true;
                tt.cascadeDown = true;
                tt.cascadeUp = true;
                break;
            case 'disable':
                tt.cascadeCheck = false;
                tt.cascadeDown = false;
                tt.cascadeUp = false;
                break;
            case 'up':
                tt.cascadeCheck = true;
                tt.cascadeUp = true;
                tt.cascadeDown = false;
                break;
            case 'down':
                tt.cascadeCheck = true;
                tt.cascadeDown = true;
                tt.cascadeUp = false;
                break;
            default:
                tt.cascadeCheck = true;
                tt.cascadeDown = true;
                tt.cascadeUp = true;
                break;
        }

        this.ins.cascadeStatus = val || 'enable';
        this.ins.personalConf.cascadeStatus = val || 'enable';
    }


    private setTreeTablePageInfo(tt: any, pageSize, pageIndex, items) {
        tt.updatePageInfo({pageSize: pageSize, pageIndex: pageIndex});
        tt.empty();
        tt.scrollToY(0);
        tt.loadData(items);

        // éä¸­è®°å½
        this.ins.selectionMgr.selectCurrentValue();
    }

    private getDataWithPageInfo(tt: TreeTableComponent, e: {pageIndex: number, pageSize: number}) {
        const { field = '*', value = '' } = {
            ...tt.searchData
        };
        this.getChildren(null,  null, { searchField:field, searchValue: value}, {pageIndex: e.pageIndex, pageSize: e.pageSize, category: 'all'}).subscribe((t: any) => {
            const { pageSize, pageIndex } = t.pageInfo;
            this.setTreeTablePageInfo(tt, pageSize, pageIndex, t.items);
        });
    }

    private treePagerEvent(tt: TreeTableComponent) {
        
        if (this.ins.treeTableOptions && this.ins.treeTableOptions.pagination) {
            // ç¦ç¨æåº æå¡å¨ç«¯ä¸æ¯æåé¡µæåº  TFS 686635
            tt.columns.forEach(n => {n.sortable = false})
            tt.pagerHeight = 44;
            // ä¸»åé¡µ
            tt.pageChanged.subscribe((e: {pageIndex: number, pageSize: number}) => {
                this.getDataWithPageInfo(tt, e);
            });
            // ä¸»åé¡µæ¡
            tt.pageSizeChanged.subscribe((pageSize: number) => {
                this.getDataWithPageInfo(tt, {pageIndex: 1, pageSize});
            });
            // å­åé¡µ
            tt.childsPageChanged.subscribe((e: {pageIndex: number, pageSize: number, node: TreeNode}) => {
                const { field = '*', value = '' } = {
                    ...tt.searchData
                };
                let parentPath = '';
                let parentLayer = -1;
                const treeInfo = this.ins.gridOptions.treeInfo;
                const tn = e.node;
                if (treeInfo.layerType === 'parentId') {
                    // ç¶IDå è½½æ¹å¼
                    parentPath = tn['id'];
                } else {
                    const treeInfoField = treeInfo.dataField;
                    if (treeInfoField) {
                        parentPath = this.ins.getPathCode(tn.data, treeInfo);
                        parentLayer = this.ins.getLayerData(tn.data, treeInfo);
                    } else {
                        this.ins.writeConsole('æªæ¾å°åçº§ä¿¡æ¯ã');
                    }
                }

                this.getChildren(parentPath,  parentLayer, { searchField:field, searchValue: value}, {pageIndex: e.pageIndex, pageSize: e.pageSize} ).subscribe((t: any) => {
                    // console.log(t);
                    this.onTreeNodeExpaned(tt, tn, t);
                });
            });
        }
    }
}
